import React from "react";
import { FaMicrophone } from "react-icons/fa";

const CurrentNews = ({ message, setAnnouncement }) => {
  return (
    <div
      className="current-news-bar"
      onClick={() => {
        if (message?.length > 0) {
          setAnnouncement(true);
        }
      }}
      style={{
        display: "flex",
        alignItems: "stretch",
        width: "100%",
        height: "24px",
        cursor: "pointer",
        overflow: "hidden",
        marginTop: "56px",
        marginBottom: "-1px",
        position: "relative",
        zIndex: 10,
        borderBottom: "1px solid transparent",
      }}
    >
      {/* Left: News label + icon */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          padding: "6px 8px",
          minWidth: "70px",
          flexShrink: 0,
          background: "linear-gradient(-180deg, #274253 0%, #0f191f 82%)",
          height: "100%",
        }}
      >
        <FaMicrophone style={{ color: "#fff", fontSize: "14px" }} />
        <span
          style={{
            color: "#fff",
            fontSize: "12px",
            fontWeight: "500",
            fontFamily: "Tahoma, Helvetica, sans-serif",
            whiteSpace: "nowrap",
            margin: 0,
            padding: 0,
          }}
        >
          News
        </span>
      </div>

      {/* Right: Scrolling text - centered vertically */}
      <div style={{ flex: 1, overflow: "hidden", display: "flex", alignItems: "center", background: "linear-gradient(-180deg, #2E4B5E 0%, #243A48 82%)", textAlign: "center", height: "100%", padding: "8px 12px" }}>
        {message?.length > 0 ? (
          <marquee direction="left" scrollamount="4" style={{ color: "#fff", fontSize: "12px", fontWeight: "600", margin: 0 }}>
            {message?.map((res, i) => (
              <span key={i}>{res?.message} &nbsp;&nbsp;&nbsp; </span>
            ))}
          </marquee>
        ) : (
          <marquee direction="left" scrollamount="4" style={{ color: "#fff", fontSize: "12px", fontWeight: "600", margin: 0 }}>
            Ball By Ball Started in Our Exchange &nbsp;&nbsp;&nbsp;
          </marquee>
        )}
      </div>
    </div>
  );
};

export default CurrentNews;
